export const MaxBuyRoute = {
  path: '/Maxbuy',
  load: () => import('./Maxbuy'),
  protected: true,
};
